import styles from './Bunner.module.scss';
import { ReactComponent as IconAlert } from './img/iconAlertOutline.svg';

export default function Bunner({
  title,
  description,
  color,
}: {
  title: string;
  description: string;
  color?: string;
}) {
  return (
    <div className={styles.info} style={{ background: color ? color : '' }}>
      <div className={styles.info_top}>
        <div className={styles.info_title}>
          <IconAlert />
          <span>{title}</span>
        </div>
      </div>
      <div>
        <p>{description}</p>
      </div>
    </div>
  );
}
